module.exports = __webpack_public_path__ + "static/img/daohang.31456f04.png";